import dynamic from 'next/dynamic'
import { useEffect, useState } from 'react'
import { isDesktop, isMobile } from '../../../client'
import { usePage } from '../../../contexts'
import {
  IGridVodItem,
  isGridVodPage,
  isLiveVodPage,
  isVodPlaylist,
} from '../../../types'
import { TopBannerFrame } from './TopBanner.styles'

const TopBannerDesktop = dynamic(
  () => import('./TopBannerDesktop').then(m => m.TopBannerDesktop),
  { ssr: false }
)
const TopBannerMobile = dynamic(
  () => import('./TopBannerMobile').then(m => m.TopBannerMobile),
  { ssr: false }
)

interface TopBannerProps {
  isVod?: boolean
}

export const TopBanner = ({ isVod }: TopBannerProps) => {
  const page = usePage()
  const [deviceType, setDeviceType] = useState<false | 'mobile' | 'desktop'>(
    false
  )

  useEffect(() => {
    setDeviceType(isDesktop() ? 'desktop' : isMobile() ? 'mobile' : false)
  }, [])

  if (
    (page?.Content?.PageGrid &&
      isVodPlaylist(page?.Content?.PageGrid[0] as IGridVodItem)) ||
    isGridVodPage(page)
  ) {
    return null
  }

  const isLive = isLiveVodPage(page)

  return (
    <TopBannerFrame dfpIsBlocked={page?.PageMeta?.ads.block.dfp}>
      {deviceType === 'desktop' && (
        <TopBannerDesktop isLive={isLive} isVod={isVod} />
      )}
      {deviceType === 'mobile' && (
        <TopBannerMobile isLive={isLive} isVod={isVod} />
      )}
    </TopBannerFrame>
  )
}
export default TopBanner
